import { z } from 'zod';

export const Uuid = z.uuid();
export const IdParams = z.object({ id: z.uuid() });
export const Ok = z.object({ ok: z.literal(true) });
export const IsoDateTime = z.iso.datetime({ offset: true });
export const KstDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/** 비율 한 개 — 항상 k/n 과 구간을 같이 싣는다(F-12). 표시 규칙은 web 이 정한다 */
export const Rate = z.object({
  k: z.number().int(),
  n: z.number().int(),
  lo: z.number().nullable(),
  hi: z.number().nullable(),
});
export type Rate = z.infer<typeof Rate>;

/**
 * 운영자 화면의 「실제 브랜드 | 테스트」 탭 (261023-test-brand). 목록·합산 라우트의 `brandKind` 쿼리다.
 * ★ **생략은 실제(real)다** — 파라미터를 빠뜨린 호출이 테스트를 섞지 않게. 서버 판정은 `isTestFilter` 한 곳
 */
export const BRAND_KINDS = ['real', 'test'] as const;
export const BrandKind = z.enum(BRAND_KINDS);
export type BrandKind = z.infer<typeof BrandKind>;
export const BrandKindQuery = z.object({ brandKind: BrandKind.optional() });
